import { COUPON_SHOW_H5_ORIGIN, IMG_PRE_URL } from '@/constants'
import DOMPurify from 'dompurify'

const pxToRem = (px: number) => {
  return px / 16 + 'rem'
}

let canIuseWebp = (() => {
  if (typeof window === 'undefined') return false;
  try {
    const canvas = document.createElement('canvas');
    if (!!(canvas.getContext && canvas.getContext('2d'))) {
      // 判断webp支持
      return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
})()

function preFixImgUrl(url: string, compress = true) {
  // 如果url已包含协议(http/https)，直接返回（不拼接IMG_PRE_URL）
  let fixUrl = /^https?:\/\//.test(url) ? url 
    : url.startsWith('/') ? `${IMG_PRE_URL}${url}` : `${IMG_PRE_URL}/${url}`;
  if (compress && canIuseWebp) {
    if (fixUrl.includes('?')) {
      fixUrl += '&x-oss-process=image/format,webp';
    } else {
      fixUrl += '?x-oss-process=image/format,webp';
    }
  }
  return fixUrl;
}

const safeJSONParse = (json: string | null | undefined, defaultValue?: any) => {
  try {
    if (typeof json !== 'string') {
      return defaultValue
    }
    return JSON.parse(json || '{}')
  } catch (error) {
    return defaultValue
  }
}


const addCommasToPrice = (price: number | string): string => {
  if (price === undefined || price === null) {
    return '--'
  }
  const _price = Number(price);
  const integerPart = Math.floor(_price).toString();
  const hasDecimal = _price % 1 !== 0;

  const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (hasDecimal) {
    const decimalPart = (_price % 1).toFixed(2).slice(2);
    return `${integerWithCommas}.${decimalPart}`;
  } else {
    return integerWithCommas;
  }
}

/**
 * 清理 HTML 内容，防止 XSS 攻击
 * @param html - 需要清理的 HTML 字符串
 * @returns 清理后的安全 HTML 字符串
 */
const sanitizeHTML = (html: string | null | undefined): string => {
  if (!html || typeof html !== 'string') {
    return ''
  }
  // 在浏览器环境中使用 DOMPurify，在服务端渲染时返回空字符串
  if (typeof window !== 'undefined') {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'a', 'img', 'div', 'span', 'blockquote', 'pre', 'code'],
      ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style', 'target', 'rel'],
      ALLOW_DATA_ATTR: false,
    })
  }
  return ''
}

export default {
  safeJSONParse,
  pxToRem,
  preFixImgUrl,
  addCommasToPrice,
  sanitizeHTML,
}

const COUPON_SHOW_H5_PATH = '/#/pages/mineCoupon/index'

/**
 * 线下「出示优惠券」二维码内嵌链接（按 PRIVATE_ENV 使用对应 H5 域名）
 */
export function buildCouponShowQrUrl() {
  return `${COUPON_SHOW_H5_ORIGIN}${COUPON_SHOW_H5_PATH}`
}

export { pxToRem, preFixImgUrl, safeJSONParse, addCommasToPrice, sanitizeHTML }